/** BookingSourceSelect — the source filter (BON-649). A select at every
 *  breakpoint: with two sources, chips would add a row for little gain. */
import { CONTROL, SOURCE_OPTIONS, type SourceValue } from './bookingFilterOptions';

export function BookingSourceSelect({
  source,
  onSourceChange,
}: {
  source: SourceValue;
  onSourceChange: (v: SourceValue) => void;
}) {
  return (
    <label className="flex items-center gap-2 text-sm text-stone-600 dark:text-stone-400">
      <span className="text-xs font-semibold uppercase tracking-wide text-stone-500">Source</span>
      <select
        aria-label="Filter by source"
        value={source}
        onChange={(e) => onSourceChange(e.target.value as SourceValue)}
        className={CONTROL}
      >
        {SOURCE_OPTIONS.map((o) => (
          <option key={o.value} value={o.value}>
            {o.label}
          </option>
        ))}
      </select>
    </label>
  );
}
